import PropTypes from "prop-types";

/**
 * Grade Level Template vs Differentiated. Same filter-row pattern as Select a Subject.
 */
const DiffContentToggle = ({ value, onChange, disabled }) => (
    <section className="epr-selector-ratings diff-rating-type">
        <h5 id="diff-rating-type-label">Select Rating Type:</h5>
        <div className="epr-options" role="tablist" aria-labelledby="diff-rating-type-label">
            <button
                type="button"
                role="tab"
                aria-selected={value === "ON_LEVEL"}
                className={value === "ON_LEVEL" ? "button-outline active" : "button-outline"}
                disabled={disabled}
                onClick={() => onChange("ON_LEVEL")}
            >
                Grade Level Template Items
            </button>
            <button
                type="button"
                role="tab"
                aria-selected={value === "DIFFERENTIATED"}
                className={value === "DIFFERENTIATED" ? "button-outline active" : "button-outline"}
                disabled={disabled}
                onClick={() => onChange("DIFFERENTIATED")}
            >
                Differentiated Items
            </button>
        </div>
    </section>
);

DiffContentToggle.propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOf(["ON_LEVEL", "DIFFERENTIATED"]).isRequired
};

export default DiffContentToggle;
